import { Questao } from "../questao.model";

export class QuestaoDTO extends Questao {

  questaoRespondida?: boolean;

  static getInstanceFromQuestao(questao: Questao): QuestaoDTO {
    const _questaoDTO = new QuestaoDTO();
    const questaoDTO: QuestaoDTO = Object.assign({}, _questaoDTO, questao);
    questaoDTO.questaoRespondida = false;

    return questaoDTO;
  }

}
